import {
	EVENT_ACTION_PARKING_PRODUCTS_SELECTED_PRODUCT,
	EVENT_CATEGORY_PARKING_PRODUCTS,
	trackCustomEvent,
} from '../../../../../../shared/analytics';
import { IParkingProduct } from '../../../../../domain/parking-product/models/IParkingProduct';

export function trackClickedParkingProduct(parkingProduct: IParkingProduct) {
	trackCustomEvent({
		category: EVENT_CATEGORY_PARKING_PRODUCTS,
		action: EVENT_ACTION_PARKING_PRODUCTS_SELECTED_PRODUCT,
		label: parkingProduct.name,
		value: parkingProduct.id,
	});
}
